import { AppTile } from '@/components/dashboard/app-tile';
import { EnvDot } from '@/components/dashboard/env-meta';
import type { CatalogApp } from '@/types/catalog';

type PinnedSectionProps = {
  apps: CatalogApp[];
};

export const PinnedSection = ({ apps }: PinnedSectionProps) => {
  if (apps.length === 0) {
    return null;
  }

  return (
    <section aria-labelledby="pinned-heading">
      <h2 id="pinned-heading" className="font-medium text-muted-foreground text-xs uppercase tracking-widest">
        Pinned
      </h2>
      <ul className="mt-3 flex flex-wrap gap-3">
        {apps.map((app) => (
          <li key={app.id}>
            <a
              href={app.launchUrl}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2.5 rounded-xl border bg-card px-3 py-2 font-medium text-sm transition-colors hover:border-primary/40 focus-visible:outline-2 focus-visible:outline-ring"
            >
              <AppTile abbr={app.abbr} color={app.color} icon={app.icon} label={app.label} size="sm" />
              {app.label}
              {app.environment && <EnvDot environment={app.environment} />}
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};
